import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { forkJoin } from 'rxjs';
import { take } from 'rxjs/operators';
import { EditSelectable } from '../../entities/formControls/edit-selectable';
import { LicenceInfo } from '../../entities/licenceInfo/licenceInfo';
import { getLicenceTypes, LicenceType } from '../../entities/payment/payment';
import { Tenant } from '../../entities/tenant/tenant';
import { User } from '../../entities/user/user';
import { LoadingService } from '../../services/loading.service';
import { PaymentsService } from '../../services/payment/payment.service';
import { TenantsService } from '../../services/tenants/tenants.service';
import { UsersService } from '../../services/users/users.service';
import { EditDialogComponent } from '../editDialog/editDialogComponent';
import { EditDialogInstance } from '../editDialog/editDialogService';
@Component({
  selector: 'app-user-licence-dialog',
  templateUrl: './user-licence-dialog.component.html',
  styleUrls: ['./user-licence-dialog.component.scss']
})
export class UserLicenceDialogComponent
  implements EditDialogInstance {

  userLicenceForm: FormGroup;
  user: User;
  licenceOptions: EditSelectable[] = [];
  tenant: Tenant;
  licenceInfos: LicenceInfo[];
  isCurrentUserNexatoEmployee: boolean = false;
  currentUsersLicenceType: string;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public userService: UsersService,
    public loadingService: LoadingService,
    public tenantService: TenantsService,
    public paymentsService: PaymentsService,
    public userSerivce: UsersService
  ) {
    // set the incoming data
    if (this.config.data) {
      this.user = this.config.data;
    }

    // check the current users licence state
    // this.isCurrentUserNexatoEmployee = this.userSerivce.isNexatoEmployee();
    this.currentUsersLicenceType = this.userSerivce.getCurrentLicenceType();

    // load current tenant and licence info, wait till loaded
    // then build the licence options
    forkJoin({
      tenant: this.tenantService.getCurrentTenant(),
      licenceInfos: this.paymentsService.getLicenceInfos()
    })
    .pipe(take(1))
    .subscribe(({ tenant, licenceInfos }) => {
      this.tenant = tenant;
      this.licenceInfos = licenceInfos;
      this.licenceOptions = this.buildLicenceOptions();
    });

    // build the form
    this.userLicenceForm = new FormGroup({});
    // add form controls
    this.userLicenceForm.addControl('licenceType', new FormControl(this.user?.licenceType.id, Validators.required));
    console.log(this.userLicenceForm);
  }
  
  buildLicenceOptions(): EditSelectable[] | undefined {
    return getLicenceTypes().map((licenceType) => {
      // probably we should move this logic into the service layer
      // find the licence info for the current licence type
      let licenceInfo = this.licenceInfos.find((licenceInfo) => licenceInfo.type === licenceType.id);
      let isAssignable = this.paymentsService.isLicenceTypeAssignable(licenceInfo, licenceType.id,
          this.user, this.tenant.paymentProviderEnabled);
      return {
        name: this.buildLicenceOptionsName(licenceType, licenceInfo), 
        id: licenceType.id,
        disabled: !isAssignable
      };
    });
  }

  buildLicenceOptionsName(licenceType: LicenceType, licenceInfo: LicenceInfo): string {
    if(!this.tenant.paymentProviderEnabled){
      return licenceType.name;
    } else {
      if(licenceInfo === undefined){
        return licenceType.name;
      } else {
      return licenceType.name + ' (' + licenceInfo?.assigned + '/' + licenceInfo?.available + ')';
      }
    }
  }


  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    console.log(this.userLicenceForm.value);
    this.loadingService.setLoading(true);
    this.userService.updateLicenceType(this.user.id, this.userLicenceForm.value.licenceType, () => {
      this.loadingService.setLoading(false);
      this.ref.close(true);
    });
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.userLicenceForm;
  }

}
